const assignmentsReducer = (state = { }, action) => {
  switch (action.type) {
    case 'ASSIGNMENT_ADD': return { ...state, [action.payload.key]: action.payload.val() };
    case 'ASSIGNMENT_REMOVE': return { ...state, [action.payload.key]: undefined };
    default: return state;
  }
};

export default assignmentsReducer;
